import { ComponentConfig } from "@measured/puck";
import { TokenizedText, TokenizedTextProps } from "./TokenizedText";
import { allTypographyVariants } from "@foodpilot/foods";
import { TypographyOwnProps } from "@mui/material";
import ColorPickerField from "../../fields/ColorPickerField";
import RichTextEditorField from "../../fields/RichTextEditorField";
import { TEXT_SPACING_OPTIONS } from "../../layoutTokens";

export type { TokenizedTextProps };

export type TypographyProps = {
    variant?: TypographyOwnProps["variant"];
    align?: "left" | "center" | "right" | "justify";
    color?: string;
    content: string;
    gutterBottom?: boolean;
    noWrap?: boolean;
    linkUrl?: string | null;
};

export const TokenizedTextConfig: ComponentConfig<TokenizedTextProps> = {
    label: "Tokenized Text",
    fields: {
        content: {
            type: "custom",
            label: "Content",
            render: (props) => <RichTextEditorField {...props} />,
        },
        variant: {
            type: "select",
            label: "Typography Variant",
            options: allTypographyVariants.map((variant) => ({
                label: variant,
                value: variant,
            })),
        },
        align: {
            type: "select",
            label: "Text Alignment",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
                { label: "Justify", value: "justify" },
            ],
        },
        color: {
            type: "custom",
            label: "Text color",
            render: (props) => <ColorPickerField {...props} />,
        },
        spacing: {
            type: "select",
            label: "Vertical spacing",
            options: TEXT_SPACING_OPTIONS,
        },
    },
    defaultProps: {
        content: "Hello {user.firstname} from {company.name}",
        variant: "body",
        align: "left",
        color: "",
        spacing: "default",
    },
    render: (props) => {
        return <TokenizedText {...props} />;
    },
};

export default TokenizedTextConfig;
